<template>
  <div class="bg-white p-2">
    <DxDataGrid id="gridContainer" v-show="!isShowDetail"
                :allow-column-reordering="true"
                :data-source="dataSources"
                :allow-column-resizing="true"
                :row-alternation-enabled="true"
                :show-borders="true"
                ref="gridContainerRef"
                :sync-lookup-filter-values="false"
                @exporting="exportGrid"
    >
      <DxScrolling row-rendering-mode="virtual"/>
      <DxPaging :page-size="15"/>
      <DxGroupPanel :visible="true"/>
      <DxGrouping :auto-expand-all="true"/>
      <DxRemoteOperations :group-paging="true"/>
      <DxFilterRow :visible="true"/>
      <DxFilterPanel :visible="false"/>
      <!--      <DxHeaderFilter :visible="true"/>-->
      <DxExport
          :enabled="true"
          :formats="['xlsx']"
      />

      <DxColumn caption="STT" cell-template="indexTemplace" width="50">
      </DxColumn>
      <template #indexTemplace="{ data }">
        <span>{{ data.rowIndex + 1 }}</span>
      </template>
      <DxColumn data-field="NGUON" caption="Nguồn" width="100"
                cell-template="sourceTemplace">
        <DxLookup
            :data-source='sourceList'
            value-expr="source"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #sourceTemplace="{ data }">
        <span
            :class="sourceList.find(item=>item.source===data.data.NGUON).COLOR || 'text-primary'"
        >
          {{ data.data.NGUON }}
        </span>
      </template>
      <DxColumn data-field="PHONE" caption="Số thuê bao">
      </DxColumn>
      <DxColumn data-field="CUSTOMER_NAME" caption="Tên khách hàng">
      </DxColumn>
      <DxColumn data-field="CALL_DATE" caption="Thời điểm gọi lên" data-type="date" sortOrder="desc">
        <DxFormat
            type="shortDateShortTime"
        />
      </DxColumn>
      <DxColumn data-field="APPROVE_DATE" caption="Thời điểm phê duyệt" data-type="date">
        <DxFormat
            type="shortDateShortTime"
        />
      </DxColumn>
      <DxColumn data-field="STATUS" caption="Trạng thái" cell-template="statusTemplace">
        <DxLookup
            :data-source='statusList'
            value-expr="STATUS"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #statusTemplace="{ data }">
        <span
            :class="data.data.STATUS===0?'text-warning':data.data.STATUS===1?'text-success':'text-primary'"
        >
          {{
            statusList.find(item => {
              return data.data.STATUS === item.STATUS
            }).TEXT
          }}
        </span>
      </template>
      <DxColumn data-field="IS_UPDATE" caption="Loại" cell-template="typeTemplace">
        <DxLookup
            :data-source='typeList'
            value-expr="isUpdate"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #typeTemplace="{ data }">
        <span
            :class="data.data.IS_UPDATE===0?'text-success':'text-info'"
        >
          {{
            getTypeText(data.data)
          }}
        </span>
      </template>
      <DxColumn data-field="ACTIVED_DATE" caption="Ngày DKTT">
      </DxColumn>
      <DxColumn data-field="TDV" caption="Tổng đài viên">
      </DxColumn>
      <DxColumn data-field="NOTE" caption="Ghi chú">
      </DxColumn>
      <DxColumn data-field="CountNumber" caption="Số lượt gọi" width="80">
      </DxColumn>
      <DxColumn caption="Video" name="video" type="buttons">
        <DxGridButton
            hint="Xem video"
            icon="fa-solid fa-circle-play"
            cssClass="text-primary"
            :on-click="watchVideoFromTable"
        />
      </DxColumn>
      <DxColumn caption="Chi tiết" name="button" type="buttons">
        <DxGridButton
            hint="Xem chi tiết"
            icon="fa-solid fa-bars"
            cssClass="text-primary"
            :on-click="openDetailModal"
        />
      </DxColumn>

    </DxDataGrid>
    <b-modal id="view-video-modal" hide-footer size="lg" title="Video">
      <video :src="video" controls playsinline style="width: -webkit-fill-available"></video>
    </b-modal>
    <b-row v-if="isShowDetail">
      <b-col cols="3">
        <b-row class="min-height-150">
          <b-col cols="12">
            <div class="card-image-container mt-0">
              <div style="position: relative;">
                <img
                    v-if="!groupImage.frontCMND"
                    class="video-image"
                    src="@/assets/images/videoCall/front-card.png"
                />
                <div v-if="groupImage.frontCMND" class="image-container">
                  <v-zoomer>
                    <img
                        :src="groupImage.frontCMND"
                        class="video-image preview-image image-zoom"
                    />
                  </v-zoomer>
                  <div class="image-details"></div>
                </div>
              </div>
              <div class="text-center text-label">Ảnh mặt trước</div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card-image-container">
              <div style="position: relative;">
                <img
                    v-if="!groupImage.backCMND"
                    class="video-image"
                    src="@/assets/images/videoCall/back-card.png"
                />
                <div v-if="groupImage.backCMND" class="image-container">
                  <v-zoomer>
                    <img
                        :data-zoom="groupImage.backCMND"
                        :src="groupImage.backCMND"
                        class="video-image preview-image image-zoom1"
                    />
                  </v-zoomer>
                  <div class="image-details1"></div>
                </div>
              </div>
              <div class="text-center text-label">Ảnh mặt sau</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3">
        <div class="card-image-container mt-0">
          <div class="d-flex justify-content-center">
            <img
                v-if="!groupImage.profilePicture"
                class="video-image"
                src="@/assets/images/videoCall/avatar.png"
            />
            <v-zoomer>
              <img
                  v-if="groupImage.profilePicture"
                  :src="groupImage.profilePicture"
                  class="video-image preview-image"
              />
            </v-zoomer>
          </div>
          <div class="text-center text-label">
            Ảnh chân dung
            <p>Tỉ lệ facematching: {{ cardInfo.faceMatching }}%</p>
          </div>
        </div>
        <div class="card-image-container mt-0">
          <div class="d-flex justify-content-center">
            <img
                v-if="!cardInfo.signData"
                class="video-image"
                src="@/assets/images/videoCall/avatar.png"
            />
            <img
                v-if="cardInfo.signData"
                :src="
                cardInfo.signData.includes('data:image')
                  ? cardInfo.signData
                  : 'data:image/jpg;base64,' + cardInfo.signData
              "
                class="video-image preview-image"
            />
          </div>
          <div class="text-label">Ảnh chữ ký</div>
        </div>
      </b-col>
      <b-col cols="6">
        <b-col cols="12">
          <b-form-group label="Nguồn" label-cols="3">
            <b-form-input
                :value="cardInfo.callSrc"
                disabled
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Kênh" label-cols="3">
            <b-form-input
                :value="cardInfo.channel"
                disabled
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số thuê bao" label-cols="3">
            <b-form-input
                v-model="cardInfo.telNumber"
                disabled
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số liên hệ" label-cols="3">
            <b-form-input
                v-model="cardInfo.contactPhone"
                disabled
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số serial" label-cols="3">
            <b-form-input
                v-model="cardInfo.serial"
                disabled
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Đối tượng sử dụng" label-cols="3">
            <b-form-input disabled size="md" type="text" value="Bản thân"/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Loại giấy tờ" label-cols="3">
            <!--                <b-form-input v-model="cardInfo.cardType" size="md" type="text"/>-->
            <select
                v-model="cardInfo.cardType"
                class="form-control"
                @change="handleChangeInfo"
            >
              <option value="1">CMT</option>
              <option value="45">CCCD</option>
              <option value="47">Căn Cước</option>
              <option value="3">Hộ chiếu</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số giấy tờ" label-cols="3">
            <b-form-input
                v-model="cardInfo.idCard"
                size="md"
                ref="idCardInput"
                type="text"
                @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <!--        <b-col cols="12">-->
        <!--          <b-form-group label="Số hộ chiếu" label-cols="3">-->
        <!--            <b-form-input size="md" type="text" @change="handleChangeInfo"/>-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->
        <b-col cols="12">
          <b-form-group label="Họ và tên" label-cols="3">
            <b-form-input
                v-model="cardInfo.name"
                size="md"
                type="text"
                ref="nameInput"
                @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ngày sinh" label-cols="3">
            <b-form-input
                v-model="cardInfo.dob"
                size="md"
                type="text"
                ref="dobInput"
                @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Giới tính" label-cols="3">
            <!--                <b-form-input v-model="cardInfo.gender" size="md" type="text"/>-->
            <select
                v-model="cardInfo.gender"
                class="form-control"
                @change="handleChangeInfo"
            >
              <option value="male">Nam</option>
              <option value="female">Nữ</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Địa chỉ" label-cols="3">
            <b-form-input
                @change="handleChangeInfo"
                v-model="cardInfo.address"
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ngày cấp" label-cols="3">
            <b-form-input
                @change="handleChangeInfo"
                v-model="cardInfo.issueDate"
                size="md"
                type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Nơi cấp" label-cols="3">
            <Select2
                v-model="cardInfo.issueAt"
                :options="issueAtList"
                placeholder="Chọn nơi cấp... "
            />
            <!--            <select-->
            <!--                v-model="cardInfo.issueAt"-->
            <!--                @change="handleChangeInfo"-->
            <!--                class="form-control"-->
            <!--            >-->
            <!--              <option-->
            <!--                  v-for="place in issuedPlaceList"-->
            <!--                  :value="place.ISSUED_PLACE_CODE"-->
            <!--              >{{ place.ISSUED_PLACE_NAME }}-->
            <!--              </option>-->
            <!--              <option value="KHAC">Khác</option>-->
            <!--            </select>-->
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Quốc tịch" label-cols="3">
            <Select2
                v-model="cardInfo.nationality"
                :options="nationalsList"
                placeholder="Chọn quốc tịch... "
            />
            <!--            <select-->
            <!--                v-model="cardInfo.nationality"-->
            <!--                @change="handleChangeInfo"-->
            <!--                class="form-control"-->
            <!--            >-->
            <!--              <option-->
            <!--                  v-for="place in nationalsList"-->
            <!--                  :value="place.id"-->
            <!--              >{{ place.name }}-->
            <!--              </option>-->
            <!--            </select>-->
          </b-form-group>
        </b-col>
        <b-col cols="12" class="font-medium-3 font-weight-bold"
        >Kết quả check C06
        </b-col>
        <b-col cols="12" class="text-primary mb-1" v-if="isErrorC06">
          <div class="d-flex align-items-baseline">
            <i
                class="fa-solid fa-triangle-exclamation mr-2"
                style="color: #ff0000;font-size: 1.5rem"
            ></i>
            <b>THUÊ BAO CHECK C06 CHƯA THÀNH CÔNG</b>
          </div>
        </b-col>
        <b-col cols="12">
          <table class="table border text-center">
            <thead>
            <tr>
              <th>STT</th>
              <th>Tên Trường</th>
              <th>Kết quả</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(field, index) in c06Field">
              <td class="border">{{ index + 1 }}</td>
              <td class="border">{{ field.name }}</td>
              <td class="border ">
                {{ field.isChecked ? (field.status ? "Đúng" : "Sai") : "" }}
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ghi chú" label-cols="3">
            <b-form-input v-model="note" size="md" type="text"/>
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
    <b-row v-if="isShowDetail" style="margin-top: 28px;">
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <button
              v-if="cardInfo.videoLink && cardInfo.videoLink.length > 0"
              class="btn btn-primary "
              @click="watchVideo()"
          >
            Xem Video
          </button>
          <button
              v-if="cardInfo.status != 1 && !isCCQ_OWNER"
              :disabled="isDisableCheckC06"
              class="btn btn-primary ml-2"
              @click="checkC06()"
          >
            Check C06
          </button>
          <button
              v-if="!isCCQ_OWNER"
              class="btn btn-primary ml-2"
              @click="searchFileSimilar()"
          >
            Kiểm tra giả mạo
          </button>
          <button
              v-if="cardInfo.status != 1 && (cardInfo.isUpdate||CCQ===1)"
              class="btn btn-primary ml-2"
              @click="onUpdateContract()"
          >
            Xem phiếu
          </button>
          <button
              v-if="cardInfo.status != 1 && (!cardInfo.isUpdate && CCQ!==1) && (!isCCQ_RECEIVER && !isCCQ_OWNER)"
              class="btn btn-primary ml-2"
              @click="onRegisterContract()"
          >
            Xem phiếu
          </button>
          <button
              v-if="cardInfo.status != 1 && (isCCQ_RECEIVER)"
              class="btn btn-primary ml-2"
              @click="onRegisterContract()"
          >
            Xem phiếu
          </button>
          <button
              v-if="cardInfo.status != 1 && (!cardInfo.isUpdate && CCQ!==1) && (!isCCQ_RECEIVER && !isCCQ_OWNER)"
              :disabled="contractBase64.length === 0"
              class="btn btn-success ml-2 "
              @click="onRegister()"
          >
            Đăng ký
          </button>
          <button
              v-if="cardInfo.status != 1 && (cardInfo.isUpdate || CCQ===1) && (!isCCQ_RECEIVER && !isCCQ_OWNER)"
              :disabled="contractBase64.length === 0"
              class="btn btn-success ml-2 "
              @click="onUpdate()"
          >
            {{ CCQ === 1 ? "Duyệt CCQ" : "Cập nhật" }}
          </button>
          <button
              v-if="cardInfo.status != 1 && (isCCQ_RECEIVER || isCCQ_OWNER)"
              class="btn btn-success ml-2 "
              @click="onConfirmCCQ()"
          >
            Xác nhận
          </button>
          <button
              v-if="cardInfo.status != 1"
              class="btn btn-secondary ml-2"
              @click="onRefuse()"
          >
            Từ chối
          </button>
          <button class="btn btn-primary ml-2" @click="hideDetail()">
            Đóng
          </button>
        </div>
      </b-col>
    </b-row>
    <b-modal
        id="modal-contract"
        :title="
        cardInfo.isUpdate
          ? 'Phiếu cập nhật thông tin thuê bao'
          : 'Phiếu đăng ký thông tin thuê bao'
      "
        hide-footer
        size="lg"
    >
      <template>
        <b-row>
          <b-col class="ml-auto" cols="12">
            <img
                :src="prefixImgLink + contractBase64"
                class="video-image"
                alt="video-image"/>
            <!--            <embed :src="'data:application/pdf;base64,'+contractBase64" style="height: 80vh; width: 55vw">-->
          </b-col>
        </b-row>
        <hr/>
      </template>
    </b-modal>
    <div
        id="modal-similar-image"
        class="similar-image-modal"
        v-if="isShowSimilarImageModal"
    >
      <template>
        <div class="d-flex justify-content-between align-items-center">
          <span class="font-medium-3">Ảnh tương tự</span>
          <button @click="isShowSimilarImageModal=false" class="btn font-medium-4 p-0">X</button>
        </div>
        <b-row class="row-gap-2 p-2 border-0 overflow-scroll" style="height: 60vh">
          <p v-if="similarImage.length===0" class="font-medium-1">Không có ảnh giấy tờ tương tự</p>
          <b-col cols="6" class="mt-2" v-for="image in similarImage">
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <p class="font-medium-1 font-weight-bold">SĐT: {{ image.stb }}</p>
                  <p class="font-medium-1 font-weight-bold">Số giấy tờ: {{ image.so_giay_to }}</p>
                </div>
                <p class="font-medium-1 font-weight-bold">{{ (parseFloat(image.score) * 100).toFixed(2) }}%</p>
              </div>
              <img
                  :src="'data:image/png;base64,' + image.image"
                  class="video-image w-100 h-100"
                  alt="video-image"/>
            </div>
          </b-col>
        </b-row>
        <hr/>
      </template>
    </div>
  </div>
</template>

<script>
import {BButton, BCol, BFormDatepicker, BFormGroup, BFormInput, BRow, BSpinner} from "bootstrap-vue";
import Select2 from "v-select2-component";
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import useJwt from "@/auth/jwt/useJwt";
import {ValidationProvider} from "vee-validate";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import {$ctx} from "@themeConfig";
import VueSignatureCanvas from "vue-signature-canvas";
import {
  DxButton as DxGridButton,
  DxColumn,
  DxDataGrid,
  DxExport,
  DxFilterPanel,
  DxFilterRow,
  DxFormat,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLookup,
  DxPaging,
  DxRemoteOperations,
  DxScrolling
} from "devextreme-vue/data-grid";
import 'devextreme/data/odata/store';
import viMessages from "devextreme/localization/messages/vi.json";
import {exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {loadMessages, locale} from "devextreme/localization";
import {Workbook} from 'exceljs';
import saveAs from 'file-saver';
import {jsPDF} from 'jspdf';
import {prefixImgLink} from "@/store/helper";
const CARD_TYPE = {
  CCCD: "45",
  CAN_CUOC: "47",
  CMT: "1",
  HO_CHIEU: "3"
};
export default {
  name: "VideoCallDSTB",
  computed: {
    $ctx() {
      return $ctx
    },
    issueAtList() {
      let tempList = []
      this.issuedPlaceList.forEach((item) => {
        tempList.push({
          id: item.ISSUED_PLACE_CODE,
          text: item.ISSUED_PLACE_NAME
        })
      })
      this.nationalsList.forEach((item) => {
        tempList.push({
          id: item.id,
          text: item.name
        })
      })
      return tempList
    },
    issueAtForSubmit() {
      if (!isNaN(this.cardInfo.issueAt)) {
        return this.issueAtList.find(item => item.id == this.cardInfo.issueAt).text;
      }
      return this.cardInfo.issueAt;
    },
    isCCQ_OWNER() {
      return this.cardInfo.serviceType === "CCQ_OWNER"
    },
    isCCQ_RECEIVER() {
      return this.cardInfo.serviceType === "CCQ_RECEIVER"
    },
    formatPhoneRegis() {
      if (this.cardInfo.telNumber.startsWith("0")) {
        return this.cardInfo.telNumber
      } else if (this.cardInfo.telNumber.startsWith("84")) {
        return this.cardInfo.telNumber.replace("84", "0");
      } else {
        return this.cardInfo.telNumber
      }
    },
  },
  components: {
    DxGrouping,
    DxFilterPanel, DxRemoteOperations, DxHeaderFilter, DxGroupPanel, DxDataGrid, DxScrolling, DxPaging,
    DxFilterRow, DxLookup, DxFormat,
    DxColumn, DxGridButton,
    BSpinner,
    BFormGroup,
    BRow,
    BCol,
    ValidationProvider, DxExport,
    BButton,
    Select2,
    BFormDatepicker,
    BFormInput,
    VueGoodTable,
    VueSignatureCanvas
  },
  created() {
    loadMessages(viMessages);
    locale("vi-VN");
  },
  data() {
    return {
      CCQ: 0,
      commitSign: "",
      contractCCQBase64: "",
      prefixImgLink,
      dataSources: {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/VIDEO_CALL_LISTs",
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      },
      statusList: [
        {STATUS: 0, TEXT: "Chưa xử lý"},
        {STATUS: 1, TEXT: "Hoàn thành"},
        {STATUS: 2, TEXT: "Từ chối"}
      ],
      typeList: [
        {isUpdate: 0, TEXT: "Đăng ký"},
        {isUpdate: 1, TEXT: "Cập nhật"},
      ],
      sourceList: [
        {source: "POS", TEXT: "POS", COLOR: "text-primary"},
        {source: "POS_CSKH", TEXT: "POS_CSKH", COLOR: "text-primary"},
        {source: "WEB", TEXT: "WEB", COLOR: "text-success"},
        {source: "APP", TEXT: "APP", COLOR: "text-info"},
        {source: "CCQ", TEXT: "CCQ", COLOR: "text-info"},
        {source: "CCQ_OWNER", TEXT: "CCQ_OWNER", COLOR: "text-info"},
        {source: "CCQ_RECEIVER", TEXT: "CCQ_RECEIVER", COLOR: "text-info"},
        {source: "SMS", TEXT: "SMS", COLOR: "text-success"},
      ],
      isShowSimilarImageModal: false,
      similarImage: [],
      isCheckSimilarImage: false,
      isShowDetail: false,
      isDisableCheckC06: false,
      issuedPlaceList: [],
      nationalsList: [],
      isErrorC06: false,
      options: {
        penColor: "rgb(56, 63, 255)",
        backgroundColor: "rgb(255, 255, 255)"
      },
      totalRecords: 0,
      groupImage: {
        frontCMND: "",
        backCMND: "",
        profilePicture: ""
      },
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      c06Field: [
        {
          id: "idnumber_result",
          name: "Số giấy tờ",
          status: false,
          isChecked: false
        },
        {
          id: "name_result",
          name: "Họ và tên",
          status: false,
          isChecked: false
        },
        {
          id: "dob_result",
          name: "Ngày sinh",
          status: false,
          isChecked: false
        }
      ],
      video: "",
      fromDate: "",
      toDate: "",
      tableData: [],
      fields: [
        {
          field: "SOURCE",
          label: "Nguồn",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              {value: 0, text: "WEB"},
              {value: 1, text: "POS"},
              {value: 2, text: "APP"}
            ]
          }
        },
        {
          field: "PHONE",
          label: "Số STB",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-center"
        },
        {
          field: "CUSTOMER_NAME",
          label: "Tên khách hàng",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-center"
        },
        {
          field: "CALL_DATE",
          label: "Thời điểm gọi lên ",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "APPROVE_DATE",
          label: "Thời điểm phê duyệt",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "STATUS",
          label: "Trạng thái",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              {value: 0, text: "Chưa đăng ký/ cập nhật"},
              {value: 1, text: "Đã đăng ký/ cập nhật"},
              {value: 2, text: "Từ chối"}
            ]
          }
        },
        {
          field: "ACTIVED_DATE",
          label: "Ngày DKTT",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "USER_APPROVE",
          label: "Người duyệt",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "TDV",
          label: "Tổng đài viên",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "NOTE",
          label: "Ghi chú",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "countNumber",
          label: "Số lượt gọi",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "video",
          label: "Video",
          tdClass: "text-center"
        },
        {
          field: "action",
          label: "Action"
        }
      ],
      user: "",
      note: "",
      userList: [],
      statusListDKTT: [
        {id: 0, text: "Chưa đăng ký"},
        {id: 1, text: "Đã đăng ký"},
        {id: 2, text: "Từ chối đăng ký"}
      ],
      statusListCNTT: [
        {id: 0, text: "Chưa cập nhật"},
        {id: 1, text: "Đã cập nhật"},
        {id: 2, text: "Từ chối cập nhật"}
      ],
      cardInfo: {
        ID: "",
        name: "",
        idCard: "",
        dueDate: "",
        dob: "",
        address: "",
        hometown: "",
        gender: "",
        issueDate: "",
        issueAt: "",
        otherIssueAt: "",
        telNumber: "",
        nationality: "",
        serial: "",
        signData: "",
        cardType: "",
        cityCode: "",
        contactPhone: "",
        faceMatching: "",
        videoLink: "",
        status: "",
        callSrc: "",
        channel: "",
        isUpdate: "",
        call_id: "",
        serviceType: ""
      },
      contractBase64: "",
      regisContractAdditional: "",
      signDataAdmin: "",
      URL_WEB_API: $ctx.API_URL.includes("dev")
          ? "https://itel.dev"
          : "https://itel.vn",
      POS_API_URL: $ctx.API_URL.includes("dev")
          ? "https://pos.itel.dev/api/pos/"
          : "https://pos.itel.vn/api/pos/",
      code:"",
      bbck:"",
    };
  },
  mounted() {
    // this.getCallList();
    this.signDataAdmin = JSON.parse(localStorage.getItem("userData")).signature;
    this.getIssuedPlace();
    this.getNationals();
  },
  methods: {
    getTypeText(data){
      if(data.NGUON==="CCQ_OWNER"){
        return "CCQ chủ cũ"
      }
      if(data.NGUON==="CCQ_RECEIVER"){
        return "CCQ chủ mới"
      }
      if(data.CCQ===1){
        return "CCQ"
      }
     return this.typeList.find(item => {
        return data.IS_UPDATE === item.isUpdate
      }).TEXT
    },
    async searchFileSimilar() {
      this.loading(true)
      this.isCheckSimilarImage = true
      useJwt
          .post("search-file-simple", {
            file: this.groupImage.frontCMND.replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", ""),
            limit: 6,
            threshold: 0.8,
            id_number: this.cardInfo.idCard
          })
          .then(res => {
            this.loading(false)
            this.similarImage = res.data.result.results
            if (this.similarImage.length > 0) {
              this.isShowSimilarImageModal = true
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có ảnh giấy tờ tương tự!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
            }

          })
          .catch(err => {
            console.log(err)
            this.loading(false)
          });
    },
    exportGrid(e) {
      if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          worksheet: worksheet,
          component: e.component,
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(new Blob([buffer], {type: "application/octet-stream"}), "DanhSachCuocGoi.xlsx");
          });
        });
      } else if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component,
        }).then(() => {
          doc.save('DanhSachCuocGoi.pdf');
        });
      }
    },
    hideDetail() {
      this.isShowDetail = false;
      // this.getCallList();
      this.$refs.gridContainerRef.instance.refresh()
    },
    getIssuedPlace() {
      useJwt
          .get("getIssuedPlace")
          .then(res => {
            this.issuedPlaceList = res.data.result;
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lấy danh sách nơi cấp thất bại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    getNationals() {
      useJwt
          .get("get-nationals")
          .then(res => {
            this.nationalsList = res.data.result.map(item => {
              return {
                id: item.id,
                text: item.name,
                name: item.name,
              };
            });
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lấy danh sách quốc gia thất bại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    checkC06() {
      if (this.cardInfo.cardType === "3") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Không kiểm tra C06 với hộ chiếu",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.isDisableCheckC06 = true;
      this.loading(true);
      this.isErrorC06 = false;
      this.c06Field.forEach(item => {
        item.status = false;
      });
      useJwt
          .post("check-info", {
            idNumber: this.cardInfo.idCard,
            phone: this.cardInfo.telNumber,
            birthDay: this.cardInfo.dob,
            fullName: this.cardInfo.name
          })
          .then(res => {
            this.isDisableCheckC06 = false;
            this.loading(false);
            if (!res.data.result) {
              if (res.data.code === 201) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "C06 Lỗi",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                this.isErrorC06 = true;
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Thông tin giấy tờ trùng khớp!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
              }
              this.c06Field.forEach(item => {
                item.status = true;
                item.isChecked = true;
              });
              this.$refs.idCardInput.state = true;
              this.$refs.nameInput.state = true;
              this.$refs.dobInput.state = true;
              this.$refs.idCardInput.disabled = true;
              this.$refs.nameInput.disabled = true;
              this.$refs.dobInput.disabled = true;
            }
            this.searchFileSimilar()
          })
          .catch(err => {
            this.isDisableCheckC06 = false;
            this.loading(false);
            if (err.response) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Thông tin giấy tờ chưa khớp với cơ sở dữ liệu dân cư quốc gia, Vui lòng kiểm tra lại thông tin giấy tờ",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              if (err.response.data.result) {
                this.c06Field.forEach(item => {
                  item.isChecked = true;
                });
                if (err.response.data.result.idnumber_result == "true") {
                  this.c06Field[0].status = true;
                  this.$refs.idCardInput.state = true;
                } else {
                  this.$refs.idCardInput.state = false;
                }
                if (err.response.data.result.name_result == "true") {
                  this.c06Field[1].status = true;
                  this.$refs.nameInput.state = true;
                } else {
                  this.$refs.nameInput.state = false;
                }
                if (err.response.data.result.dob_result == "true") {
                  this.$refs.dobInput.state = true;
                  this.c06Field[2].status = true;
                } else {
                  this.$refs.dobInput.state = false;
                }
              }
            }
          });
    },
    handleChangeInfo() {
      this.contractBase64 = "";
    },
    onColumnFilter(params) {
      console.log(params);
      this.serverParams = {
        columnFilters: params.columnFilters,
        page: 1,
        pageSize: 50
      };
      this.getCallList();
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage;
      this.serverParams.page = 1;
      this.getCallList();
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.getCallList();
    },
    watchVideo() {
      // this.showLoading(true);
      if (this.video === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Cuộc gọi không có video",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        return;
      }
      this.$bvModal.show("view-video-modal");
      // useJwt
      //   .post("download-video/" + id, {})
      //   .then(res => {
      //     this.video = "data:video/mp4;base64," + res.data.result;
      //     this.$bvModal.show("view-video-modal");
      //     this.showLoading(false);
      //   })
      //   .catch(err => {
      //     this.showLoading(false);
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: "Cuộc gọi không có video",
      //         icon: "AlertTriangleIcon",
      //         variant: "danger"
      //       }
      //     });
      //   });
    },
    mapVideoLink(link) {
      if (link) {
        if (link.includes("video1")) {
          this.video = "https://hn.ss.bfcplatform.vn/videocall/" + link;
        } else {
          this.video = "https://hn.ss.bfcplatform.vn/itel-shop-test/" + link;
        }
      } else {
        this.video = "";
      }
    },
    watchVideoFromTable(data) {
      const row = data.row.data
      this.showLoading(true);
      useJwt
          .post("get-list-his-call-detail/" + row.ID, {
            page: 1,
            pageSize: 1000
          })
          .then(res => {
            this.showLoading(false);
            let data = res.data.result[res.data.result.length - 1];
            if (data.VIDEO_LINK) {
              this.mapVideoLink(data.VIDEO_LINK);
              this.watchVideo(data.ID);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cuộc gọi không có video",
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            }
          })
          .catch(err => {
            this.showLoading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Có lỗi xảy ra vui lòng thử lại",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    async getCallList() {
      this.showLoading(true);
      useJwt
          .post("get-list-his-call", this.serverParams)
          .then(res => {
            this.showLoading(false);
            this.totalRecords = res.data.totalRecords;
            this.tableData = res.data.result.map(e => {
              e.CALL_DATE = moment(e.CALL_DATE).format("YYYY-MM-DD HH:mm:ss");
              e.REGISTER_DATE = e.REGISTER_DATE
                  ? moment(e.REGISTER_DATE).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              e.APPROVE_DATE = e.APPROVE_DATE
                  ? moment(e.APPROVE_DATE).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              if (e.POS_AGEN_ID && e.POS_AGEN_ID.length > 0) {
                if (e.POS_AGEN_ID == 0) {
                  e.SOURCE = "APP";
                } else {
                  e.SOURCE = "POS";
                }
              } else {
                e.SOURCE = "WEB";
              }
              if (e.SOURCE === "WEB") {
                e.SOURCE_TEXT_COLOR = "text-warning";
              }
              if (e.SOURCE === "APP") {
                e.SOURCE_TEXT_COLOR = "text-info";
              }
              if (e.SOURCE === "POS") {
                e.SOURCE_TEXT_COLOR = "text-primary";
              }
              e.soLuotGois = "";
              e.video = "";
              e.action = "";
              return e;
            });
          })
          .catch(err => {
            this.showLoading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Có lỗi xảy ra vui lòng thử lại",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    async openDetailModal(data) {
      const row = data.row.data
      this.showLoading(true);
      this.video = "";
      useJwt
          .post("get-list-his-call-detail/" + row.ID, {
            page: 1,
            pageSize: 1000
          })
          .then(res => {
            let data = res.data.result[res.data.result.length - 1];
            if (data.BIRTH_DAY.length === 4) {
              data.BIRTH_DAY = "01/01/" + data.BIRTH_DAY;
            }
            this.cardInfo.ID = data.ID;
            this.cardInfo.call_id = data.CALL_ID;
            this.cardInfo.name = data.FULL_NAME;
            this.cardInfo.idCard = data.ID_NUMBER;
            this.cardInfo.dueDate = moment(data.ISSUE_DATE, "DD/MM/YYYY").format(
                "DD/MM/YYYY"
            );
            this.cardInfo.dob = moment(data.BIRTH_DAY, "DD/MM/YYYY").format(
                "DD/MM/YYYY"
            );
            this.cardInfo.address = data.ADDRESS;
            this.cardInfo.hometown = data.HOME_TOWN;
            this.cardInfo.gender = data.GENDER;
            this.cardInfo.issueDate = moment(
                data.ISSUE_DATE,
                "DD/MM/YYYY"
            ).format("DD/MM/YYYY");
            this.cardInfo.telNumber = data.PHONE;
            this.cardInfo.serial = data.SERI;
            this.cardInfo.signData = data.IMAGE4 !== ""
                ? "data:image/jpeg;base64," + data.IMAGE4
                : "";
            //check loai giay to
            if (data.CARD_TYPE == "CCCD") {
              this.cardInfo.cardType = "45";
            } else if (data.CARD_TYPE == "CMT") {
              this.cardInfo.cardType = "1";
            } else {
              this.cardInfo.cardType = data.CARD_TYPE;
            }
            //check noi cap
            if (data.ISSUE_PLACE) {
              if (data.VIDEO_SOURCE_DETAIL === "jitsi") {
                this.cardInfo.issueAt = data.ISSUE_PLACE;
              } else {
                if(isNaN(data.ISSUE_PLACE)){
                  if (data.ISSUE_PLACE.length == 3) {
                    this.cardInfo.issueAt = data.ISSUE_PLACE;
                  } else {
                    this.onCheckIssueAt(
                        data.ISSUE_PLACE,
                        this.cardInfo.cardType == "1"
                    );
                  }
                }
                else {
                  this.cardInfo.issueAt = parseInt(data.ISSUE_PLACE)
                }
              }
            } else {
              this.cardInfo.issueAt = "";
            }
            this.cardInfo.cityCode = data.CITY_CODE;
            this.cardInfo.contactPhone = data.CONTACT_PHONE;
            this.cardInfo.faceMatching = data.FACE_MATCHING;
            this.cardInfo.videoLink = data.VIDEO_LINK;
            this.cardInfo.status = row.STATUS;
            this.cardInfo.posAgenId = data.POS_AGEN_ID;
            this.cardInfo.channel = data.CHANEL;
            this.cardInfo.deviceId = data.DEVICE_ID
            if (this.cardInfo.posAgenId && this.cardInfo.posAgenId.length > 0) {
              if (this.cardInfo.posAgenId == 0) {
                this.cardInfo.callSrc = "APP";
              } else {
                this.cardInfo.callSrc = "POS";
              }
            } else {
              this.cardInfo.callSrc = "WEB";
            }
            if (data.VIDEO_SOURCE === "jitsi" && this.cardInfo.posAgenId != 0) {
              this.cardInfo.callSrc = "POS_CSKH";
            }
            if (data.VIDEO_SOURCE === "web") {
              this.cardInfo.callSrc = "SMS";
            }
            if (data.CCQ === 1) {
              this.CCQ = 1;
              this.cardInfo.callSrc = "APP";
            } else {
              this.CCQ = 0
            }
            this.cardInfo.serviceType = row.NGUON
            if (this.isCCQ_OWNER) {
              if (this.cardInfo.posAgenId == 0) {
                this.cardInfo.callSrc = "APP";
              } else {
                this.cardInfo.callSrc = "POS_CSKH";
              }
              this.cardInfo.channel = "Chuyển chủ quyền chủ cũ"
            }
            if (this.isCCQ_RECEIVER) {
              if (this.cardInfo.posAgenId == 0) {
                this.cardInfo.callSrc = "APP";
              } else {
                this.cardInfo.callSrc = "POS_CSKH";
              }
              this.cardInfo.channel = "Chuyển chủ quyền chủ mới"
            }
            this.commitSign = data.COMMIT_SIGN
            this.cardInfo.nationality = this.cardInfo.cardType!==CARD_TYPE.HO_CHIEU?"232": data.INTERNATIONAL;
            this.cardInfo.isUpdate = row.IS_UPDATE;
            this.note = data.NOTE1 ? data.NOTE1 : "";
            this.groupImage.frontCMND = data.IMAGE1
                ? "data:image/jpeg;base64," + data.IMAGE1
                : "";
            this.groupImage.backCMND = data.IMAGE2
                ? "data:image/jpeg;base64," + data.IMAGE2
                : "";
            this.groupImage.profilePicture = data.IMAGE3
                ? "data:image/jpeg;base64," + data.IMAGE3
                : "";
            this.contractBase64 = "";
            this.mapVideoLink(data.VIDEO_LINK);
            this.c06Field.forEach(item => {
              item.status = false;
              item.isChecked = false;
            });
            this.isCheckSimilarImage = false
            this.code=""
            this.bbck=""
            // this.$bvModal.show("call-detail-modal");
            this.isShowDetail = true;
            // setTimeout(() => {
            //   new Drift(document.querySelector(".image-zoom"), {
            //     paneContainer: document.querySelector(".image-details"),
            //     zoomFactor: 4
            //   });
            //   new Drift(document.querySelector(".image-zoom1"), {
            //     paneContainer: document.querySelector(".image-details1"),
            //     zoomFactor: 4
            //   });
            // }, 1000);
            this.showLoading(false);
          })
          .catch(err => {
            console.log("err openDetailModal-->", err);
            this.showLoading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Có lỗi xảy ra vui lòng thử lại",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    async onCheckIssueAt(issueAt, isCMT) {
      this.loading(true);
      const params = {
        type: isCMT ? "CMT" : "CCCD",
        placeName: issueAt
      };
      await useJwt
          .post(
              "issuedPlace",
              params
          )
          .then(
              response => {
                this.loading(false);
                // console.log("response --->", response);
                this.cardInfo.issueAt = response.data.data.onSelect.issuedPlaceCode;
              },
              error => {
                this.loading(false);
                console.log("error", error);
              }
          );
    },
    async onRefuse() {
      // if(this.cardInfo.callSrc==='WEB') return
      if (this.note.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập ghi chú!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      await useJwt
          .post("refuse/" + this.cardInfo.telNumber, {
            note: this.note
          })
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Đã từ chối thuê bao!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message
                    ? err.response?.data?.message
                    : "Từ chối thuê bao thất bại! Vui lòng thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    showLoading(type) {
      if (type) {
        document.getElementById("loading-bg").style.display = "block";
      } else {
        document.getElementById("loading-bg").style.display = "none";
      }
    },
    async saveNote() {
      await useJwt
          .get(
              "update-note/" +
              this.cardInfo.call_id +
              "/" +
              this.cardInfo.telNumber,
              {
                params: {
                  msg: this.note
                }
              }
          )
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu ghi chú thành công",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu ghi chú thất bại",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    async onGetBBCK() {
      if(this.code.length===0) return
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob,
        psQuoctich: this.nationalsList.find(item => item.id == this.cardInfo.nationality)?.name,
        psnoicap: this.issueAtForSubmit,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate,
        img1: "",
        img2: "",
        img3: "",
        signatureImage: this.cardInfo.signData.replace("data:image/jpeg;base64,", "")
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", ""),
        psContactPhone: this.cardInfo.contactPhone,
        psHomeTown: this.cardInfo.hometown,
        psCityCode: this.cardInfo.cityCode,
        faceMatching: this.cardInfo.faceMatching,
        agency_signatureImage: this.signDataAdmin
            .replace("data:image/jpeg;base64,", "")
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", ""),
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
        agentCode: this.cardInfo.posAgenId,
        call_id: this.cardInfo.call_id,
        code:this.code
      };
      if(this.cardInfo.callSrc === "APP"  ){
        await useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_BBCK_VD", data,
                {
                  timeout: 120000
                }
            )
            .then(res => {
              if (res?.data?.code == 200) {
                this.bbck=res.data.result.img4_link
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if(this.cardInfo.callSrc === "POS" ||this.cardInfo.callSrc === "POS_CSKH"){
       await axios
            .post(
                this.POS_API_URL + "pos_sub_registration_form_BBCK_VD", data,
                {
                  timeout: 120000
                }
            )
            .then(res => {
              if (res?.data?.code == 200) {
                this.bbck=res.data.result.img4_link
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }

    },
    async onRegister() {
      this.loading(true);
      await this.onGetBBCK()
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        ...(this.cardInfo.cardType === "3" && {personNumber: this.cardInfo.idCard}),
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: this.cardInfo.nationality,
        nationalityid: this.cardInfo.nationality,
        psnoicap: this.issueAtForSubmit,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
            ? this.groupImage.frontCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img2: this.groupImage.backCMND
            ? this.groupImage.backCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img3: this.groupImage.profilePicture
            ? this.groupImage.profilePicture
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        hd: this.contractBase64,
        call_id: this.cardInfo.call_id,
        device_id: this.cardInfo.deviceId,
        bbck:this.bbck,
        code:this.code
      };
      if (this.note.length > 0) {
        this.saveNote();
      }
      if (this.cardInfo.channel === "TGDD"||this.cardInfo.channel === "STL") {
        useJwt
            .post("pos_sub_registration_tgdd", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
        return;
      }
      if (this.cardInfo.callSrc === "WEB" || this.cardInfo.callSrc === "POS_CSKH" || this.cardInfo.callSrc === "SMS") {
        useJwt
            .post("pos_sub_registration", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.cardInfo.callSrc === "POS") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_registration_VD",
                {
                  tdv: JSON.parse(localStorage.getItem("userData")).email,
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.cardInfo.callSrc === "APP") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_registration_VD",
                {
                  tdv: JSON.parse(localStorage.getItem("userData")).email,
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
    },
    async onUpdate() {
      this.loading(true);
      await this.onGetBBCK()
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        ...(this.cardInfo.cardType === "3" && {personNumber: this.cardInfo.idCard}),
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: this.cardInfo.nationality,
        nationalityid: this.cardInfo.nationality,
        psnoicap: this.issueAtForSubmit,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
            ? this.groupImage.frontCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img2: this.groupImage.backCMND
            ? this.groupImage.backCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img3: this.groupImage.profilePicture
            ? this.groupImage.profilePicture
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        hd: this.contractBase64,
        img5: this.cardInfo.isUpdate===1?this.regisContractAdditional: this.contractCCQBase64,
        call_id: this.cardInfo.call_id,
        device_id: this.cardInfo.deviceId,
        code:this.code,
        bbck:this.bbck
      };
      if (this.note.length > 0) {
        this.saveNote();
      }
      let isCanTransfer=true
      if (this.isCCQ_RECEIVER) {
        useJwt
            .get("videocall/ccqReceiver/checkRequest/" + this.cardInfo.idCard + "/" + this.formatPhoneRegis)
            .then(res => {
              if (res?.data?.code !== 200) {
                isCanTransfer=false
                this.loading(false);
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Yêu cầu chuyển quyền đã bị hủy!";
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              isCanTransfer=false
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Yêu cầu chuyển quyền đã bị hủy!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if(!isCanTransfer){
        return;
      }
      if (this.cardInfo.callSrc === "WEB" || this.cardInfo.callSrc === "POS_CSKH" || this.cardInfo.callSrc === "SMS") {
        useJwt
            .post("pos_sub_update_info", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã cập nhật thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                if (this.isCCQ_RECEIVER) {
                  this.onConfirmCCQReviver()
                }
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Cập nhật thông tin lỗi!";
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Cập nhật thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.cardInfo.callSrc === "POS") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_update_info_VD",
                {
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã cập nhật thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Cập nhật thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Cập nhật thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.cardInfo.callSrc === "APP") {
        useJwt
            .post(
                "pos_sub_update_info",
                {
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã cập nhật thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                if (this.isCCQ_RECEIVER) {
                  this.onConfirmCCQReviver()
                }
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Cập nhật thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Cập nhật thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
    },
    updateStatusRegis() {
      useJwt
          .post("update-status-regis", {
            name: this.cardInfo.name,
            msisdn: this.cardInfo.telNumber,
            source: "OUTCALL",
            call_id: this.cardInfo.call_id
          })
          .then(res => {
            if (res.data.code === 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cập nhật trạng thái thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message
                      ? res.data.message
                      : "Cập nhật trạng thái lỗi!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.data.message
                    ? err.response.data.message
                    : "Cập nhật trạng thái lỗi!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    clearSign() {
      this.$refs.handWriteAdmin.clearSignature();
      this.signDataAdmin = "";
    },
    async onCCQContract() {
      const data = {
        subscribers: [
          {
            phone: this.formatPhoneRegis,
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob,
        psQuoctich: this.nationalsList.find(item => item.id == this.cardInfo.nationality)?.name,
        psnoicap: this.issueAtForSubmit,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate,
        img1: "",
        img2: "",
        img3: "",
        signatureImage: this.commitSign?.replace("data:image/jpeg;base64,", "")
            ?.replace("data:image/png;base64,", "")
            ?.replace("data:image/jpg;base64,", ""),
        psContactPhone: this.cardInfo.contactPhone,
        psHomeTown: this.cardInfo.hometown,
        psCityCode: this.cardInfo.cityCode,
        faceMatching: this.cardInfo.faceMatching,
        agency_signatureImage: JSON.parse(localStorage.getItem("userData"))
            .signature,
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
        call_id: this.cardInfo.call_id
      };
      if (this.CCQ === 1) {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/ccq_image",
                data
            )
            .then(res => {
              this.contractCCQBase64 = res.data.result.img4_link;
              // this.$bvModal.show("modal-contract-ccq");
              // this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không tạo được phiếu CCQ!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.isCCQ_RECEIVER) {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/termination2_image",
                {
                  ...data,
                  signatureImage: this.cardInfo.signData?.replace("data:image/jpeg;base64,", "")
                      ?.replace("data:image/png;base64,", "")
                      ?.replace("data:image/jpg;base64,", "")
                }
            )
            .then(res => {
              this.contractCCQBase64 = res.data.result.img4_link;
              this.code = res.data.result.code ? res.data.result.code : null;
              // this.$bvModal.show("modal-contract-ccq");
              // this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không tạo được phiếu CCQ!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if(this.code.length>0){
        await this.onGetBBCK()
      }
    },
    async onUpdateContract() {
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.c06Field[1].status && !this.c06Field[2].status && this.cardInfo.cardType != "3") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.isCheckSimilarImage) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra giả mạo!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob,
        psQuoctich: this.nationalsList.find(item => item.id == this.cardInfo.nationality)?.name,
        psnoicap: this.issueAtForSubmit,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate,
        img1: "",
        img2: "",
        img3: "",
        signatureImage: this.cardInfo.signData.replace("data:image/jpeg;base64,", "")
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", ""),
        psContactPhone: this.cardInfo.contactPhone,
        psHomeTown: this.cardInfo.hometown,
        psCityCode: this.cardInfo.cityCode,
        faceMatching: this.cardInfo.faceMatching,
        agency_signatureImage: this.signDataAdmin
            .replace("data:image/jpeg;base64,", "")
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", ""),
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
        call_id: this.cardInfo.call_id
      };
      if (this.CCQ === 1) {
        let isCanUpdate=true
        await useJwt
            .get("get-phone-in-idNumber/" + this.cardInfo.idCard)
            .then(async res => {
              if (res.data?.result?.result?.length >= 3 && this.callSrc !== "POS_CSKH") {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Số giấy tờ đã đươợc đăng ký 3 số thuê bao!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
                this.loading(false);
                isCanUpdate = false
              }
            })
        if (!isCanUpdate) return
        await this.onCCQContract()
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP_CCQ",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              // this.code = res.data.result.code ? res.data.result.code:null
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi tạo phiếu!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
        return
      }
      await this.onAdditionRegisterContract(data);
      if (this.cardInfo.callSrc === "WEB" || this.cardInfo.callSrc === "SMS") {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              // this.code = res.data.result.code ? res.data.result.code:null
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.cardInfo.callSrc === "POS_CSKH") {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf_cskh",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              // this.code = res.data.result.code ? res.data.result.code:null;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.cardInfo.callSrc === "POS") {
        useJwt
            .postEx(this.POS_API_URL + "pos_sub_update_info_form_vd", {
              agentCode: this.cardInfo.posAgenId,
              ...data
            })
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              // this.code = res.data.result.code ? res.data.result.code:null;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.cardInfo.callSrc === "APP") {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf_APP",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              // this.code = res.data.result.code ? res.data.result.code:null;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      await this.onGetBBCK()
    },
    async onRegisterContract() {
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.c06Field[1].status && !this.c06Field[2].status && this.cardInfo.cardType != "3") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.isCheckSimilarImage) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra giả mạo!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      useJwt
          .get("get-phone-in-idNumber/" + this.cardInfo.idCard)
          .then(async res => {
            console.log(res.data?.result?.result);
            if (res.data?.result?.result?.length >= 3 && this.cardInfo.callSrc !== "POS_CSKH") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Số giấy tờ đã đươợc đăng ký 3 số thuê bao!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
              return;
            }
            const data = {
              subscribers: [
                {
                  phone: this.cardInfo.telNumber.replace("84", "0"),
                  seri: this.cardInfo.serial
                }
              ],
              psHoten: this.cardInfo.name,
              psCmnd: this.cardInfo.idCard,
              psNgaysinh: this.cardInfo.dob,
              psQuoctich: this.nationalsList.find(item => item.id == this.cardInfo.nationality)?.name,
              psnoicap: this.issueAtForSubmit,
              psdiachi: this.cardInfo.address,
              psGioiTinh: this.cardInfo.gender,
              ploaigt: this.cardInfo.cardType,
              psplacedate: this.cardInfo.issueDate,
              img1: "",
              img2: "",
              img3: "",
              signatureImage: this.cardInfo.signData.replace("data:image/jpeg;base64,", "")
                  .replace("data:image/png;base64,", "")
                  .replace("data:image/jpg;base64,", ""),
              psContactPhone: this.cardInfo.contactPhone,
              psHomeTown: this.cardInfo.hometown,
              psCityCode: this.cardInfo.cityCode,
              faceMatching: this.cardInfo.faceMatching,
              agency_signatureImage: this.signDataAdmin
                  .replace("data:image/jpeg;base64,", "")
                  .replace("data:image/png;base64,", "")
                  .replace("data:image/jpg;base64,", ""),
              tdv: JSON.parse(localStorage.getItem("userData")).fullName,
              call_id: this.cardInfo.call_id
            };
            if (this.isCCQ_RECEIVER) {
              await this.onCCQContract()
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
              return
            }
            if (this.cardInfo.callSrc === "WEB" || this.cardInfo.callSrc === "SMS") {
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.code = res.data.result.code ? res.data.result.code:null;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
            if (this.cardInfo.callSrc === "POS_CSKH") {
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf_cskh",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.code = res.data.result.code ? res.data.result.code:null;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
            if (this.cardInfo.callSrc === "POS") {
              useJwt
                  .postEx(this.POS_API_URL + "pos_sub_registration_form_VD", {
                    agentCode: this.cardInfo.posAgenId,
                    ...data
                  })
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.code = res.data.result.code ? res.data.result.code:null
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
            if (this.cardInfo.callSrc === "APP") {
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.code = res.data.result.code ? res.data.result.code:null
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
          })
          .catch(err => {
            this.loading(false);
          });
    },
    async onAdditionRegisterContract(data) {
      if (this.callSrc === "WEB") {
       await useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf",
                data
            )
            .then(res => {
              this.regisContractAdditional = res.data.result.img4_link;
              this.code = res.data.result.code ? res.data.result.code:null
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.callSrc === "POS_CSKH") {
       await useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf_cskh",
                data
            )
            .then(res => {
              this.regisContractAdditional = res.data.result.img4_link;
              this.code = res.data.result.code ? res.data.result.code:null
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.callSrc === "POS") {
       await useJwt
            .postEx(this.POS_API_URL + "pos_sub_registration_form_VD", {
              agentCode: this.cardInfo.posAgenId,
              ...data
            })
            .then(res => {
              this.regisContractAdditional = res.data.result.img4_link;
              this.code = res.data.result.code ? res.data.result.code:null
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.callSrc === "APP") {
       await useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP",
                data
            )
            .then(res => {
              this.regisContractAdditional = res.data.result.img4_link;
              this.code = res.data.result.code ? res.data.result.code:null
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
    },
    async onConfirmCCQ() {
      if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày cấp phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày sinh phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      const data = {
        phone: this.formatPhoneRegis,
        idNumber: this.cardInfo.idCard,
        tdv1Sign: JSON.parse(localStorage.getItem("userData")).signature,
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
      };
      if (this.note.length > 0) {
        this.saveNote();
      }
      if (this.isCCQ_OWNER) {
        useJwt
            .post("videocall/ccqOwner/confirmRequest", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Xác nhận thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                this.updateStatusRegis();
              } else {
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Xác nhận thông tin lỗi!";
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Xác nhận thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
        return
      }
      if (this.isCCQ_RECEIVER) {
        await this.onUpdate()
      }
    },
    async onConfirmCCQReviver() {
      const data = {
        phone: this.formatPhoneRegis,
        idNumber: this.cardInfo.idCard,
        tdv1Sign: JSON.parse(localStorage.getItem("userData")).signature,
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
      };
      this.loading(true)
      useJwt
          .post("videocall/ccqReceiver/confirmRequest", data, {
            timeout: 120000
          })
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Xác nhận thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
            } else {
              const errText = res?.data?.message
                  ? res?.data?.message
                  : "Xác nhận thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            const errText = err?.response?.data?.message
                ? err?.response?.data?.message
                : "Xác nhận thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
  }
};
</script>

<style lang="scss">
#call-detail-modal {
  .modal-dialog {
    max-width: 95vw !important;
  }
}

#view-video-modal {
  .modal-dialog {
    width: fit-content;
  }
}
</style>
<style lang="scss" scoped>
.card-image-container {
  margin-top: 65px;
  position: relative;

  .text-label {
    text-align: center;
    margin-top: 11px;

    color: #4b4b4b;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }

  .camera-icon {
    position: absolute;
    right: 21px;
    bottom: 14px;
    cursor: pointer;
  }
}

.video-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.similar-image-modal {
  top: 20%;
  right: 2%;
  z-index: 25 !important;
  width: 37%;
  padding: 1%;
  height: fit-content;
  position: fixed;
  background: white;
  border: 1px solid #434343;
  border-radius: 10px;
  box-shadow: 2px 5px 8px #888888;
}
</style>
